import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import OverviewMobile from "./OverviewMobile";
import OverviewDesktop from "./OverviewDesktop";

function Overview({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <OverviewMobile app={app} config={config} />
  ) : (
    <OverviewDesktop app={app} config={config} />
  );
}

Overview.defaultProps = {
  app: null,
  config: {},
};

Overview.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Overview;
